<div class="booking-report" *ngIf="!loading(); else spinner">
  <div class="page-header">
    <button mat-icon-button [routerLink]="['/bookings', bookingId()]" aria-label="Назад к бронированию">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">Отчёт по бронированию</h1>
  </div>

  <p class="hint">На iPhone/в Telegram используйте «Поделиться», чтобы сохранить переносы строк.</p>

  <pre class="report-text">{{ reportText() }}</pre>

  <div class="actions">
    <button mat-raised-button color="primary" type="button" (click)="share()"
            [disabled]="!reportText()" class="full-width-btn">
      <mat-icon>share</mat-icon> Поделиться
    </button>
    <button mat-stroked-button type="button" (click)="copy()"
            [disabled]="!reportText()" class="full-width-btn">
      <mat-icon>content_copy</mat-icon> Скопировать
    </button>
    <button mat-stroked-button type="button" [routerLink]="['/bookings', bookingId()]" class="full-width-btn">
      <mat-icon>arrow_back</mat-icon> Назад к бронированию
    </button>
  </div>
</div>

<ng-template #spinner>
  <div class="loading-container"><mat-spinner diameter="40"></mat-spinner></div>
</ng-template>
